<p-dialog [(visible)]="dialogFormVisible"
          [header]="dialogFormTitle+recordName"
          [modal]="true" styleClass="p-fluid"
          [closeOnEscape]="true" (onShow)="onShow();"
          (onHide)="dialogFormVisibleChange.emit(false)"
          appendTo="body" position="top"
          [resizable]="false">
  <ng-template pTemplate="content">
    <app-cc-detail #ccDetail [transPartKey]="transPartKey"
                 [formConfig]="formConfig" [formRecord]="formRecord"
    ></app-cc-detail>

  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="closeDialog()"
            [label]="closeButtonLabel?closeButtonLabel:'common.dialog.close' | translate"
            class="p-button-warning p-button-sm"></button>
  </ng-template>
</p-dialog>
